// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3higP","footer":"ReportModalFilter_footer__3TpUR"};